import React, { useMemo, useCallback } from 'react';
import { useApp } from '@dex/bubl-dash/src/lib/functions/useApp';
import { useForm } from '@dex/bubl-dash/src/lib/functions/useForm';
import { Row, Col, Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import HostsApi from '../HostsApi';
import HostsCreateEditForm from './HostsCreateEditForm';
import HostsRatesForm from './HostsRatesForm';

const HostsSingleEdit: React.FC<any> = (props: any) => {

    const app = useApp();

    const manageGlobal = app.userCan(['manageGlobal'], false);

    const { data } = props;

    const form = useForm(data);

    const update = HostsApi.update(data.id, "update", {
        onComplete: (data) => {

            app.alert('Hosts Saved', 'success');

        }
    });

    const handleSubmit = useCallback((values) => {

        update.run({ data: values });

    }, [props]);

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <HostsCreateEditForm
                    mode={"edit"}
                    form={form}
                    data={data}
                    handleSubmit={handleSubmit}
                    process={update}
                />

                {manageGlobal &&
                    <>
                        <Space />

                        <HostsRatesForm
                            data={data}
                        />
                    </>
                }

            </Col>

        </Row>

    ), [data, form, update]);

}

export default HostsSingleEdit;
